<template>
  <!-- Container as modal contains another modal -->
  <div class="modal-container">
    <b-modal ref="forward-family-modal-ref" hide-footer hide-header>
      <div class="vtd-modal-content">
        <div class="vtd-modal-header modal-header-assistance">
          <h4 class="vtd-modal-title">Forward to Contact</h4>
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click="closeModal"
          >
            <span aria-hidden="true"
              ><i class="material-icons">&#xE5CD;</i></span
            >
          </button>
        </div>
        <div class="vtd-modal-body">
          <div class="modal-email-friend">
            <p>
              Keep friends, family and colleagues up to date with your
              arrangements - fill in your details below and we will send 
              on your travel plans without the prices.
            </p>
            <form
              name="friendForm"
              class="form-horizontal"
              @submit.prevent="submit"
            >
              <div
                class="vtd-form-group"
                :class="{ 'alert alert-danger': $v.form.send_to.$error }"
              >
                <label for="email1">Recipients Email address*</label>
                <input
                  id="email1"
                  ref="sendTo"
                  v-model.trim="$v.form.send_to.$model"
                  class="vtd-form-control vtd-form-control-lg form-control"
                  type="email"
                  required
                  placeholder="Enter email"
                />
              </div>

              <div
                class="vtd-form-group"
                :class="{ 'alert alert-danger': $v.form.userName.$error }"
              >
                <label>Your name*</label>
                <input
                  v-model="form.userName"
                  class="vtd-form-control vtd-form-control-lg form-control"
                  type="text"
                  required
                  placeholder="Enter your name"
                />
              </div>

              <div
                class="vtd-form-group"
                :class="{ 'alert alert-danger': $v.form.bcc.$error }"
              >
                <label for="email1">Your email address*</label>
                <input
                v-model="form.bcc"
                  id="email1"
                  class="vtd-form-control vtd-form-control-lg form-control"
                  type="email"
                  required
                  placeholder="Enter your email"
                />
              </div>

              <div class="vtd-form-group">
                <label for="message1">Your message</label>
                <textarea
                  id="message1"
                  v-model="form.email_body"
                  class="vtd-form-control vtd-form-control-lg form-control"
                  rows="6"
                />
              </div>

              <button
                v-show="!emailSent"
                type="submit"
                class="modal-submit-btn"
                @click.prevent="submit"
              >
                Send
              </button>
              <button
                v-show="emailSent"
                type="button"
                class="modal-submit-btn"
                @click="sendAnother()"
              >
                Send Another
              </button>
              <p
                v-if="formSubmit.showErrorMessage"
                :class="formSubmit.errorClass"
                class="vtd-alert vtd-alert-danger vtd-text-center vtd-m-0 vtd-mt-3"
              >
                {{ formSubmit.errorMessage }}
              </p>
            </form>
          </div>
        </div>
        <div class="btn-wrap">
          <div class="vtd-modal-footer vtd-bg-faded vtd-flex-column">
            <small
              >This information was generated at:
              <strong class="return-date">{{ returnDate }}</strong></small
            >
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import dayjs from '@/lib/dayjs';
import { required, email } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import { postEmail } from "./services";
import { processResponse } from "@/lib/utilities";
export default {
  validations: {
    form: {
      send_to: { required, email },
      userName: { required },
      bcc: { required, email },
    },
  },
  data() {
    return {
      form: {
        send_to: "",
        userName: "",
        bcc: "",
        hidePricing: true,
        email_body: "",
        from: "Trailfinders Itinerary <do-not-reply@trailfinders.com>",
        subject: "",
        bookno: "",
        bookname: "",
        version:'3',
        originator_system: "FriendsAndFamily",
        ieBooking : false
      },
      emailSent: false,
      formSubmit: {
        errorMessage: "",
        errorClass: "alert alert-danger",
        showErrorMessage: false,
      },
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapGetters("booking", [
      "getBookingName",
      "getBookingNumber",
      "getBookingSurname",
    ]),
    returnDate() {
      return dayjs().format("DD-MMM-YYYY HH:mm");
    },
    bookingNumber() {
      return this.getBookingNumber;
    },
    bookingSurname() {
      return this.getBookingSurname;
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    init() {
      this.form.userName = this.bookingSurname;
      this.form.bookno = this.bookingNumber;
      this.form.subject = this.getBookingName + "'s Trailfinders Itinerary";
      this.form.bookname = this.getBookingSurname;
      this.form.ieBooking = this.bookingNumber && this.bookingNumber.startsWith('R') ? true : false
    },
    async showModal() {
      this.$refs["forward-family-modal-ref"].show();
    },
    closeModal() {
      this.$refs["forward-family-modal-ref"].hide();
    },
    sendAnother() {
      this.emailSent = false;
      this.formSubmit.showErrorMessage = false;
      this.form.send_to = "";
      document.getElementById("email1").focus();
    },
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.init();
        await this.postEmail();
      }
    },
    async postEmail() {
      // Check required fields before submit
      const emailData = {
        ...this.form,
        bcc: [this.form.bcc, "emailchecks@trailfinders.com"]
      }

      const result = await postEmail(emailData);
      if (result.error) {
        this.formSubmit = processResponse("sendError");
      } else {
        this.formSubmit = processResponse("success");
        this.emailSent = true;
        setTimeout(() => {
          this.closeModal()
        }, 6000);
      }
    },
  },
};
</script>
<style lang="scss">
@import "./style.scss";
@import "../../home/assistance/style.scss";
.message {
  margin-bottom: 20px;
}
</style>
